<template>
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.55" y="0.55" width="12.9" height="12.9" rx="6.45" fill="white" />
    <rect
      x="0.55"
      y="0.55"
      width="12.9"
      height="12.9"
      rx="6.45"
      stroke="#252525"
      stroke-width="1.1"
    />
    <path
      d="M7.2026 10.2002V6.86666C7.2026 6.55237 7.2026 6.39523 7.10496 6.29759C7.00732 6.19995 6.85018 6.19995 6.53589 6.19995"
      stroke="#252525"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.03576 4.19995H7.04175"
      stroke="#252525"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
